import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from "../../../src/types";
import { languages, checkLineCount, combineErrors, signatureInfo, size, getContentField } from "./shared";

const marriageText = 'Wir wünschen euch, dass euer gemeinsames Leben von einem fröhlichen Miteinander und einem liebevollen Füreinander getragen ist. Das verleiht eurer Ehe die zarte Lebendigkeit, die sie so schön macht, und diese stille Kraft, die sie allem standhalten lässt, was immer geschehen mag.'


export const marriageTemplateData: CustomerTemplate = {
    key: 'marriage',
            name: {
                de: 'Vermählungs-Karte',
                en: 'Marriage card'
            },
            ...size,
            languages,
            signatureInfo,
            templateData: [
                {
                    key: 'headlineTop',
                    name: {
                        en: 'Headline Top',
                        de: 'Überschrift obere Zeile'
                    },
                    languageData: {
                        'de': 'Herzlichen Glückwunsch',
                        'en': 'Congratulations'
                    },
                    maxLength: 12,
                    hide: false,
                    isValid: combineErrors([checkLineCount(1)])
                },
                {
                    key: 'headlineBottom',
                    name: {
                        en: 'Headline Bottom',
                        de: 'Überschrift untere Zeile'
                    },
                    languageData: {
                        'de': 'zur Vermählung',
                        'en': 'on the marriage'
                    },
                    maxLength: 12,
                    hide: false,
                    isValid: combineErrors([checkLineCount(1)])
                },
                getContentField(marriageText)
            ],
            font: {
                headlineTop: {
                    family: 'Tangerine-Bold',
                    color: '#000', 
                    size: 55,
                    TopPadding: 250,
                    lineHeight: 55
                },
                headlineBottom: {
                    family: 'Tangerine-Bold',
                    color: '#000', 
                    size: 55,
                    TopPadding: 250,
                    lineHeight: 55
                },
                doubleHeadline: true,
                content: {
                    family: 'Roboto-Light',
                    color: '#000', 
                    size: 16,
                    TopPadding: 360,
                    lineHeight: 20
                }
            },
            signature: {
                topPadding: 590,
                contentDep: false,
                singleSignature: false,
                fontSize: 30,
                fontSizeSub: 10,
                color: '#000'
            }
}